module.exports = __webpack_public_path__ + "img/供应链共享平台ico.3eaee5bc.png";